document.addEventListener('DOMContentLoaded', function() {
  initializeVideoAutoplay();
});

// Re-initialize when page changes or sections are updated
window.addEventListener('load', function() {
  initializeVideoAutoplay();
});

// Support for theme editors
document.addEventListener('shopify:section:load', function() {
  initializeVideoAutoplay();
});

function initializeVideoAutoplay() {
  // Initialize section animations
  const sections = document.querySelectorAll('[data-animate-section]');
  sections.forEach((section) => {
    if (section.dataset.animationInitialized === 'true') {
      return;
    }

    const animateItems = section.querySelectorAll('.video-autoplay-animate-item');
    
    const observerOptions = {
      threshold: 0.15, // Trigger when 15% of section is visible
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Trigger animation
          animateItems.forEach((item) => {
            item.classList.add('is-animated');
          });
        }
      });
    }, observerOptions);

    observer.observe(section);
    section.dataset.animationInitialized = 'true';
  });

  // Initialize video playback
  const videos = document.querySelectorAll('.video-autoplay-element');

  videos.forEach((video) => {
    // Remove existing observer if any
    if (video.dataset.observerInitialized === 'true') {
      return;
    }

    // Create intersection observer to play video when it enters viewport
    const observerOptions = {
      threshold: 0.25, // Trigger when 25% of video is visible
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Video is in viewport - play it
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              // Browser prevented autoplay - this is normal on some devices/browsers
              console.log('Video autoplay prevented:', error);
            });
          }
        } else {
          // Video is out of viewport - pause it
          video.pause();
        }
      });
    }, observerOptions);

    observer.observe(video);
    video.dataset.observerInitialized = 'true';
  });
}
